export class SessionAttendeeParticipationConstants{
    public static readonly ParticipationName_Enrolled: string = 'Enrolled';
    public static readonly ParticipationClassName_Enrolled: string = 'enrolled';
    public static readonly ParticipationName_Attended: string = 'Attended';
    public static readonly ParticipationClassName_Attended : string = 'attended';
    public static readonly ParticipationName_Absent: string = 'Absent';
    public static readonly ParticipationClassName_Absent: string = 'absent';
    public static readonly ParticipationName_Waitlist: string = 'Waitlist';
    public static readonly ParticipationClassName_Waitlist: string = 'waitlist';
    public static readonly ParticipationName_Withdrawn: string = 'Withdrawn';
    public static readonly ParticipationClassName_Withdrawn: string = 'withdrawn';


    public static readonly MaxAttendeesConstantText : string = 'A maximum of 50 attendees can be selected at a time. If more are required, please add in separate lots (max 50 each).';
}
